<template>
    <div>
        <DetailsData ref="details"></DetailsData>
        <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
            style="min-width: 1200px"
        >
            <template v-if="isNew">
                <el-tab-pane
                    label="广告数据上传"
                    name="adUpload"
                    style="padding: 0 25px"
                >
                    <adUpload
                        v-if="activeName === 'adUpload'"
                        ref="adUpload"
                    ></adUpload>
                </el-tab-pane>
                <el-tab-pane
                    label="广告组基础信息"
                    name="AddBaseAdData"
                    style="padding: 0 25px;"
                >
                    <AddBaseAdData
                        v-if="'AddBaseAdData' === activeName"
                    ></AddBaseAdData>
                </el-tab-pane>
				<el-tab-pane
				    label="默认Acos"
				    name="AddBaseAcos"
				    style="padding: 0 25px;"
				>
				    <AddBaseAcos
				        v-if="activeName === 'AddBaseAcos'"
				    ></AddBaseAcos>
				</el-tab-pane>
                <el-tab-pane
                    label="广告优化-逻辑层面"
                    name="adBetter"
                    style="padding: 0 25px"
                >
                    <adBetter
                        v-if="activeName === 'adBetter'"
                        ref="adBetter"
                    ></adBetter>
                </el-tab-pane>
                <el-tab-pane
                    label="一段时间种子词数据"
                    name="timeEtymta"
                    style="padding: 0 25px"
                >
                    <timeEtymta
                        v-if="activeName === 'timeEtymta'"
                        ref="timeEtymta"
                    ></timeEtymta>
                </el-tab-pane>
                <el-tab-pane
                    label="一段时间asin数据"
                    name="timeAsin"
                    style="padding: 0 25px"
                >
                    <timeAsin
                        v-if="activeName === 'timeAsin'"
                        ref="timeAsin"
                    ></timeAsin>
                </el-tab-pane>
                <el-tab-pane
                    label="合理分析列表"
                    name="rationality_analysis"
                    style="padding: 0 25px"
                >
                    <rationality_analysis
                        v-if="activeName === 'rationality_analysis'"
                    ></rationality_analysis>
                </el-tab-pane>

                <el-tab-pane
                    label="数据趋势"
                    name="dataTrend"
                    style="padding: 0 25px"
                >
                    <dataTrend
                        v-if="activeName === 'dataTrend'"
                    ></dataTrend>
                </el-tab-pane>
				<el-tab-pane
				    label="单线程结构"
				    name="singleThread"
				    style="padding: 0 25px"
				>
				    <singleThread
				        v-if="activeName === 'singleThread'"
				    ></singleThread>
				</el-tab-pane>
                <el-tab-pane
                    label="SP每日广告活动报告"
                    name="spActivityReport"
                    style="padding: 0 25px"
                >
                    <spActivityReport
                        v-if="activeName === 'spActivityReport'"
                    ></spActivityReport>
                </el-tab-pane>
            </template>
            <template v-else>
                <el-tab-pane
                    v-if="!isNew"
                    label="Listing详情数据"
                    name="Listing"
                    style="padding: 0 25px"
                >
                    <LisShow ref="LisShow"></LisShow>
                </el-tab-pane>

                <el-tab-pane
                    label="广告优化"
                    v-if="!isNew"
                    name="ad"
                    style="padding: 0 25px"
                >
                    <Ad ref="ad"></Ad>
                </el-tab-pane>
                <el-tab-pane
                    v-if="!isNew"
                    label="防止内部竞价--逻辑层面"
                    name="preventBid"
                    style="padding: 0 25px"
                >
                    <preventBid ref="preventBid"></preventBid>
                </el-tab-pane>
                <el-tab-pane
                    v-if="!isNew"
                    label="防止内部竞价--投放层面"
                    name="inside"
                    style="padding: 0 25px"
                >
                    <Inside ref="inside" :type="2"></Inside>
                </el-tab-pane>
            </template>

            <!-- <el-tab-pane label="Listing产品详情" name="product" style="padding: 0 25px;">
                <ranking ref="ranking"></ranking>
                <increase ref="increase" style="margin: 20px 0;"></increase>
                <product ref="product"></product>
            </el-tab-pane> -->
            <!-- <el-tab-pane label="变体对比" name="variant">
                <variant1 ref="variant1"></variant1>
                <variant2 ref="variant2"></variant2>
                <variant3 ref="variant3"></variant3>
            </el-tab-pane>
            <el-tab-pane label="流量关键词" name="keyword">
                <view3 ref="view3"></view3>
            </el-tab-pane>
            <el-tab-pane label="全景动态" name="panorama"></el-tab-pane>
            <el-tab-pane label="竞品对比" name="compete"></el-tab-pane> -->
        </el-tabs>
    </div>
</template>

<script>
import Product from "./product";
import Ranking from "./ranking";
import Increase from "./increase";
import DetailsData from "./detailsData";
import Variant1 from "./variant1";
import Variant2 from "./variant2";
import Variant3 from "./variant3";
import LisShow from "./lisShow";
import preventBid from "./components/preventBid";
import adUpload from "./components/adUpload";
import adBetter from "./components/adBetter";
import timeEtymta from "./components/timeEtymta";
import AddBaseAdData from "./components/addBaseAdData";
import AddBaseAcos from "./components/addBaseAcos";
import rationality_analysis from "./components/rationality_analysis";
import dataTrend from "./components/data_trend";
import singleThread from "./components/single_thread";
import timeAsin from "./components/timeAsin";
import Inside from "../adGroup/inside/index";
import Ad from "./ad";
import spActivityReport from './components/spActivityReport'

export default {
    components: {
        AddBaseAdData,
		AddBaseAcos,
        Product,
        Ranking,
        Increase,
        DetailsData,
        Variant1,
        Variant2,
        Variant3,
        LisShow,
        Ad,
        preventBid,
        adUpload,
        adBetter,
        Inside,
        timeEtymta,
        rationality_analysis,
        dataTrend,
        timeAsin,
		singleThread,
        spActivityReport
    },
    data() {
        return {
            activeName: "Listing",
            screenWidth: document.body.clientWidth
        };
    },
    computed: {
        isNew() {
            return this.$route.query.isNew === "true";
        }
    },
    created() {
        let that = this;
        if (this.isNew) {
            this.activeName = "adUpload";
        }
        window.onresize = () => {
            return (() => {
                window.screenWidth = document.body.clientWidth;
                that.screenWidth = window.screenWidth;
            })();
        };
    },
    watch: {
        screenWidth(val) {
            // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
            if (!this.timer) {
                // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
                this.screenWidth = val;
                this.timer = true;
                this.qie_tab(this.activeName);
            }
        }
    },
    methods: {
        // qie_tab(tab) {
        //     let that = this;
        //     if (tab == "product") {
        //         setTimeout(function() {
        //             that.$refs.ranking.screenWidth();
        //             that.$refs.increase.screenWidth();
        //             that.$refs.product.screenWidth();
        //             that.timer = false;
        //         }, 400);
        //     } else if (tab == "variant") {
        //         setTimeout(function() {
        //             if (that.$refs.variant1) that.$refs.variant1.screenWidth();
        //             if (that.$refs.variant2) that.$refs.variant2.screenWidth();
        //             if (that.$refs.variant3) that.$refs.variant3.screenWidth();
        //             that.timer = false;
        //         }, 400);
        //     }
        // },
        handleClick({ paneName }) {
            this.$nextTick(() => {
                this.$refs[paneName] && this.$refs[paneName].getList();
            });
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
/deep/ .el-card__header {
    padding: 14px 20px !important;
}

/deep/ .el-tabs__content {
    overflow: visible !important;
}

/deep/ .el-card {
    overflow: visible !important;
}
</style>
